import { post, get } from "./utils";

// fast统一接口
export const excuteFassScript = (params?: any) =>
  post("NHPFCore_excuteFassScript", params, undefined, "jd_nethp_patient_h5");

// 医院详情
export const getHospitalDetailByHospitalId = (params?: any) =>
  post(
    "NHPFCoreHInfo_getHospitalDetailById",
    params,
    undefined,
    "jd_nethp_patient_h5"
  );
